/** @jsxImportSource solid-js */
import type { JSX } from "solid-js";
import { type WidgetIconName, WIDGET_ICON_PATHS } from "../utils/widget-icons";

type WidgetIconProps = {
  name: WidgetIconName;
  size: number;
  strokeWidth?: number;
};

export function WidgetIcon(props: WidgetIconProps): JSX.Element {
  const strokeWidth = () => props.strokeWidth ?? 2;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size}
      height={props.size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width={strokeWidth()}
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      innerHTML={WIDGET_ICON_PATHS[props.name]}
    />
  );
}
